import { z } from 'zod/v4';

import { styleBagSchema } from '../../../common/schemas/legacy';

import { navigationLegacyDataSchema } from './data';

/**
 * Legacy `navigation` widget envelope — its only placement (`params.type: ['specific']`, header or
 * footer column only). No `type` discriminator, same reasoning as indent/logo: this widget has one
 * shape and is created via the plain-widget factory path that never stamps one.
 */
export const navigationLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('navigation'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    data: navigationLegacyDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
